/* @flow */

// Librairies
import * as React from 'react';
import { Field } from 'formik';
import { useDebouncedCallback } from 'use-debounce';

// Utils
import { getUserId, getUserFullName } from '@braindate/domain/lib/user/util';

// Components
import FormikFormGroup from 'src/shared/app/base/component/data-entry/form/FormikFormGroup';
import FormikAutocomplete from 'src/shared/app/base/component/data-entry/form/FormikAutocomplete';
import { userAutocompleteFieldName } from './FieldUserAutocomplete';
import UserBanner, {
  small,
} from 'src/shared/components/domain/user/banner/UserBanner';
import UserAvatar, {
  xsmall as xSmallUserAvatar,
} from 'src/shared/components/domain/user/avatar/UserAvatar';

// Types
import type { User } from '@braindate/domain/lib/user/type';

type Props = {
  handleSearch: () => void,
  handleChange: () => void,
  isFetching: boolean,
  users: User[],
  label: string,
  readOnly?: boolean,
  disabled?: boolean,
  // Self passed
};

const FieldUserAutocompleteDumb = ({
  handleSearch,
  handleChange,
  users,
  isFetching,
  label,
  readOnly,
  disabled,
}: Props): React.Node => {
  const debouncedHandleSearch = useDebouncedCallback(handleSearch, 200);
  const handleSearchInput = (value: string) => debouncedHandleSearch(value);

  return (
    <Field
      name={userAutocompleteFieldName}
      required
      onChange={handleChange}
      component={FormikFormGroup}
      componentOpts={{
        label,
        inputComp: FormikAutocomplete,
        inputOpts: {
          isFetching,
          readOnly,
          disabled,
          options: users,
          renderOption: (props, value) => (
            <span {...props}>
              <UserBanner user={value} variant={small} />
            </span>
          ),
          isOptionEqualToValue: (option, value) =>
            option && value && getUserId(option) === getUserId(value),
          getOptionLabel: (option) => getUserFullName(option),
          onInputChange: (_event, value) => handleSearchInput(value),
          startAdornment: (value) => (
            <UserAvatar user={value} variant={xSmallUserAvatar} />
          ),
        },
      }}
    />
  );
};

export default React.memo<Props>(FieldUserAutocompleteDumb);
